import { assert } from '@sama/js-core';
import { flatMap, matches } from '@sama/micro-dash';
import { TagsState } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { Tags } from '../../../team-apis/otterdam/annotation-operations/tags';

type ShapeOrObjectLocationOperationAttributes = { tags: Tags };

export class InternalToExternalConverter {
  convertDynamicTagsToExternal(
    tagsState: TagsState,
    frameNumber: number,
  ): ShapeOrObjectLocationOperationAttributes | undefined {
    const outputNameTagTuples = flatMap(
      tagsState.dynamic_tags,
      (outputTags, outputName) => {
        assert(outputTags, 'outputTags should be defined');
        return outputTags
          .filter(matches({ frame_number: frameNumber }))
          .map((tag) => [outputName, tag.value]);
      },
    );

    if (outputNameTagTuples.length === 0) {
      return undefined;
    }
    const tags = Object.fromEntries(outputNameTagTuples);
    return { tags };
  }
}
